export default "__VITE_ASSET__CytOcYlr__"